import React from 'react';
import { DataContext } from './DataContext';
const DataConsumer = props => {
  return /*#__PURE__*/React.createElement(DataContext.Consumer, null, data => {
    return data && /*#__PURE__*/React.createElement(React.Fragment, null, React.Children.map(props.children, child => {
      return /*#__PURE__*/React.cloneElement(child, {
        data
      });
    }));
  });
};
export default DataConsumer;